import { useState, useEffect } from "react"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"
import { message } from "antd"
import $api from "@/api"

let timer
function Enroll() {
  const classnames = classModuleGenerator(styles)
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [vcode, setVcode] = useState("")
  const [sendBtnDisabled, setSendBtnDisabled] = useState(false)
  const [sendBtnValue, setSendBtnValue] = useState("发送验证码")
  const [countdown, setCountDown] = useState(60)

  const handleSubmit = async () => {
    if (!name) {
      return message.error("请输入您孩子的姓名")
    }
    if (!/^\d{6}$/.test(vcode)) {
      return message.error("请输入6位数字验证码")
    }

    const { result } = await $api.form.submit({
      name,
      phone,
      vcode,
    })
    if (result.code) message.error(result.message || "保存失败")
    else {
      message.success("提交成功！")
    }
  }

  const tencentCaptcha = () => {
    const phonereg =
      /^1(3[0-9]|47|5((?!4)[0-9])|6(2|5|6)|7((?!4)[0-8])|8[0-9]|9(1|5|8|9))\d{8}$/ //手机号码正则验证
    if (!phonereg.test(phone)) return message.error("请输入正确的手机号码")
    setSendBtnDisabled(true)
    const captcha = new window.TencentCaptcha("2030433147", function (res) {
      if (res.ticket) {
        sendVcode(res)
      } else {
        setSendBtnDisabled(false)
      }
    })
    captcha.show()
  }
  useEffect(() => {
    if (countdown > 0 && countdown < 60) {
      setSendBtnValue(`${countdown}s后可重发`)
    } else {
      clearInterval(timer)
      setSendBtnDisabled(false)
      setCountDown(60)
      setSendBtnValue("发送验证码")
    }
  }, [countdown])
  const sendVcode = async ({ ticket, randstr }) => {
    const res = await $api.captcha.send({
      account: phone,
      ticket,
      randstr,
    })
    timer = setInterval(() => {
      setCountDown((c) => --c)
    }, 1000)
  }

  useEffect(() => {
    return () => clearInterval(timer)
  }, [])

  return (
    <section className={classnames("enroll-container")}>
      <div>
        <h4 style={{ textAlign: "center" }}>
          在学大办理全日制，我们拥有了再次努力的动力！
        </h4>
        <div className={classnames("enroll-from")}>
          <div className={classnames("enroll-from-row")}>
            <input
              type="text"
              placeholder="您孩子的姓名："
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              placeholder="您的联系方式："
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <button
              id="sendCode"
              onClick={tencentCaptcha}
              disabled={sendBtnDisabled}
            >
              {sendBtnValue}
            </button>
          </div>
          <div className={classnames("enroll-from-row")}>
            <input
              type="text"
              placeholder="输入验证码"
              value={vcode}
              onChange={(e) => setVcode(e.target.value)}
            />
            <button style={{ width: "680px" }} onClick={handleSubmit}>
              抢免费到校参观机会
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Enroll

// import { Modal, Button } from "antd"
// import { useState } from "react"
// import CustomerForm from "@/component/customerForm"

// function Enroll() {
//   const [visible, setVisible] = useState(false)
//   function handleCancelModal() {
//     setVisible(false)
//   }
//   function handleShowModal() {
//     setVisible(true)
//   }
//   return (
//     <div style={{ textAlign: "center" }}>
//       <Button type="primary" onClick={handleShowModal}>
//         立即报名
//       </Button>
//       <Modal
//         title="立即报名"
//         visible={visible}
//         onCancel={handleCancelModal}
//         footer={null}
//       >
//         <CustomerForm callback={handleCancelModal} />
//       </Modal>
//     </div>
//   )
// }

// export default Enroll

// function loadTCaptcha() {
//   return (
//     <>
//       <script
//         url="https://ssl.captcha.qq.com/TCaptcha.js"
//         onError={handleScriptError}
//         onLoad={handleScriptLoad}
//       />
//     </>
//   )
// }
